import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap';
import { useController } from 'react-hook-form';

const propTypes = {
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  defaultValue: PropTypes.string,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  rows: PropTypes.number,
};
const defaultProps = {
  label: '',
  defaultValue: '',
  placeholder: '',
  disabled: false,
  className: '',
  rows: 3,
};

export function TextArea(props) {
  const { label, disabled, placeholder, className, name } = props;
  const { field, formState } = useController(props);
  const checkIfErrorsExists = (obj) =>
    !!(obj && obj.errors[name] && Object.keys(obj.errors[name]).length);

  const renderTextArea = (cols) => (
    <textarea
      cols={cols}
      name={name}
      {...field}
      disabled={disabled}
      placeholder={placeholder}
      className={classNames(className, 'form-control', {
        'is-invalid': checkIfErrorsExists(formState),
      })}
      id="formTextArea"
      rows="3"
    />
  );

  return (
    <div className="form textarea mb-3 mb-3">
      {label.length > 0 ? (
        <Row>
          <Col sm={12} xl={3} md={3} className="label-container">
            <label htmlFor="formTextArea" className="col-form-label">
              {label}
            </label>
          </Col>
          <Col sm={12} xl={9} md={9} className="field-container">
            {renderTextArea(8)}
            <div
              className={classNames('invalid-feedback', {
                show: checkIfErrorsExists(formState),
              })}
            >
              {formState.errors[name]?.type === 'required' &&
                `${label} is required`}
            </div>
          </Col>
        </Row>
      ) : (
        <Row>
          <Col sm={12} xl={12} md={12} className="field-container">
            {renderTextArea()}
          </Col>
        </Row>
      )}
    </div>
  );
}

TextArea.propTypes = propTypes;
TextArea.defaultProps = defaultProps;
